import React from "react";
import { Navbar, Nav, Button } from "react-bootstrap";
import logo from "../../../assets/img/logo.png";
import profileicon from "../../../assets/img/profile-icon.png";
import { useNavigate } from "react-router-dom";

const CounsellorNavbar = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.clear();
  
    // Forcefully navigate to login
    navigate("/login", { replace: true });
  
    // Prevent both back and forward navigation using pushState
    window.history.pushState(null, "", window.location.href);
  
    // Intercept back and forward button navigation
    window.onpopstate = function () {
      setTimeout(() => {
        navigate("/login", { replace: true });
        window.history.pushState(null, "", window.location.href); // Keep trapping
      }, 1500); // 1.5s delay for back/forward
    };
  };
  // useEffect(() => {
  //   const isLoggedIn = localStorage.getItem("yourAuthKey");
  //   if (!isLoggedIn) {
  //     navigate("/login");
  //   }
  // }, []);
    

  return (
    <Navbar
      bg="white"
      variant="light"
      className="container-fluid"
      sticky="top"
      expand="lg"
      style={{
        padding: "0px 10px",
        borderBottom: "0.5px solid lightgray",
        width: "auto",
      }}
    >
      <Navbar.Brand href="/">
        <img
          src={logo}
          alt="Logo"
          width="70"
          height="70"
          className="d-inline-block align-top"
        />
      </Navbar.Brand>

      <Navbar.Toggle aria-controls="navbar-nav" />
      <Navbar.Collapse id="navbar-nav" className="justify-content-end">
        <Nav>{/* Add more Nav.Links here if needed */}</Nav>
        <Button variant="danger" size="md" onClick={handleLogout}>
          Logout
        </Button>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <img
          src={profileicon}
          alt="Profile"
          width="55"
          height="55"
          className="d-inline-block align-top"
        />
      </Navbar.Collapse>
    </Navbar>
  );
};

export default CounsellorNavbar;
